var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownloadSimple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 104 99",
    style: {
      enableBackground: "new 0 0 104 99"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#2D2D2D;}\r\n\t.st1{fill:#7D7D7D;}\r\n\t.st2{fill:#464646;}\r\n\t.st3{fill:#D04A02;}\r\n\t.st4{fill:#E0301E;}\r\n\t.st5{fill:#DB536A;}\r\n\t.st6{fill:#FFFFFF;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Page-1_3_",
    d: "M52,64.3L34.7,47c-0.9-0.9-0.9-2.3,0-3.2c0.9-0.9,2.3-0.9,3.2,0l11.9,11.9V13.5h4.5v42.2l11.9-11.9 c0.9-0.9,2.3-0.9,3.2,0c0.9,0.9,0.9,2.3,0,3.2L52,64.3z M31.8,85.5V81h40.4v4.5H31.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadSimple);
export default __webpack_public_path__ + "static/media/downloadSimple.f50c7431019f90f12d924c5e8d973ac4.svg";
export { ForwardRef as ReactComponent };